export default __webpack_public_path__ + "static/media/12.c34d84f4.jpeg";